module.exports = __webpack_public_path__ + "1f7dece0705bcd919961deb7b1930fce.MP3";